const createFeatureObject = (entity: string) => ({
  FULL: `full:${entity}`,
  LIST: `list:${entity}`,
  SHOW: `show:${entity}`,
  CREATE: `create:${entity}`,
  UPDATE: `update:${entity}`,
  DELETE: `delete:${entity}`,
});

export const TEAM_FEATURES = createFeatureObject('team');
